import useLogger from "./useLogger";
import usePortalType from "./usePortalType";

const useTrackLoginAttempt = () => {
  const logger = useLogger();
  const portalType = usePortalType();

  return (userName) => {
    logger.trackEvent("Login Attempt", {
      portal: portalType ?? "",
      userName: userName ?? "",
    });
  };
};

export default useTrackLoginAttempt;
